import { OfferConstruct } from "~/server/types/brand";

export function isOfferAvailed(offerConstruct: OfferConstruct): boolean {
  if (
    offerConstruct.type === "SUBSCRIPTION_REWARD" &&
    offerConstruct.userOfferConstructStatus === "ACTIVE"
  ) {
    return true;
  }

  if (
    offerConstruct.type === "ONE_TIME_REWARD" &&
    offerConstruct.userOfferConstructStatus === "APPLIED"
  ) {
    return true;
  }

  return false;
}
